import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M316.28 514.711L699.53 131.46c17.574-17.573 17.574-46.066 0-63.64-17.573-17.573-46.066-17.573-63.64 0L189 514.712l446.891 446.892c17.574 17.573 46.067 17.573 63.64 0 17.574-17.574 17.574-46.066 0-63.64L316.28 514.711z\" p-id=\"2557\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol